module.exports = __webpack_public_path__ + "img/ivy-logo.ce54cd20.png";